import { component } from 'picoapp'

export default component(({ node: el, state, action }) => {
  const toggle = el.querySelector('.js-toggle-grid')
  const exhibit = el.querySelector('.js-exhibit')
  toggle.addEventListener('click', () => {
    const homeGrid = document.querySelector('.js-home-grid')
    if (exhibit) {
      exhibit.classList.toggle('hidden')
    }
    toggle.classList.toggle('open')
    if (homeGrid) {
      homeGrid.classList.toggle('block')
    }

  })
  return {
    onStateChange (state) {
      console.log('taco')
    }
  }
})
